import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/app-check';


// ====================================================================================
// IMPORTANTE: Reemplaza este objeto con la configuración de tu propio proyecto de Firebase.
// Puedes encontrarla en la consola de Firebase, en la configuración de tu proyecto
// (Project Settings > General > Your apps > SDK setup and configuration).
// ====================================================================================
const firebaseConfig = {
  apiKey: "AIzaSyCDtDsnkneZslHQ96xOuiS0wXCtSH0rdxk",
  authDomain: "miscuentas360.firebaseapp.com",
  projectId: "miscuentas360",
  storageBucket: "miscuentas360.firebasestorage.app",
  messagingSenderId: "378739074745",
  appId: "1:378739074745:web:af22a9df231dc48dcc9d68",
  measurementId: "G-GL37L3RWG6"
};

// --- CONFIGURACIÓN DE APP CHECK PARA DESARROLLO LOCAL ---
// Este bloque DEBE ejecutarse ANTES de firebase.initializeApp() para que el modo de depuración de App Check funcione.
if (window.location.hostname === 'localhost') {
    console.log("Modo de desarrollo local detectado. Habilitando token de depuración de App Check...");
    // Establecer esta bandera global le dice al SDK de Firebase que genere y use un token
    // de depuración automáticamente, evitando la necesidad de reCAPTCHA en localhost.
    (window as any).self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}


let auth: firebase.auth.Auth | null = null;
let db: firebase.firestore.Firestore | null = null;
let functions: firebase.functions.Functions | null = null;
let firebaseError: string | null = null;

try {
    // Inicializa Firebase con el SDK de compatibilidad, evitando reinicializaciones.
    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }
    
    auth = firebase.auth();
    db = firebase.firestore();
    functions = firebase.functions();
    
    // Inicializa App Check. El SDK usará automáticamente el proveedor de depuración en
    // localhost porque la bandera FIREBASE_APPCHECK_DEBUG_TOKEN se estableció antes.
    firebase.appCheck();

    // Habilitar la persistencia offline con soporte multi-tab
    db.enablePersistence({ synchronizeTabs: true })
      .catch(() => {
        // Silenciar errores de persistencia — la app funciona sin offline
      });

    // Establecer el idioma para los correos electrónicos de autenticación
    auth.languageCode = 'es';
    
} catch (e: any) {
    console.error("Error al inicializar Firebase:", e.message);
    firebaseError = `Error al conectar con Firebase: ${e.message}`;
}

// Inicializa el proveedor de Google
const googleProvider = new firebase.auth.GoogleAuthProvider();

// Exporta el servicio de autenticación y el posible error para usarlo en la aplicación
export { auth, db, functions, firebaseError, googleProvider };